import { Link, Outlet, useLocation } from "react-router-dom";

import logo from "../../assets/images/logo.png";
import homeIcon from "../../assets/images/icons/home-outline.svg";
import documentIcon from "../../assets/images/icons/document-outline.svg";
import classNames from "classnames";
import useLogin from "../../hooks/useLogin";
import Menu from "../../components/menu/Menu";

export default function Dashboard() {
    const [userStatus, auth] = useLogin("/login");
    const location = useLocation();
    const route = location.pathname.split("/")[2];

    return (
        <div className="flex min-h-screen flex-col bg-xv-bg-1 text-lg text-white md:flex-row">
            <div className="">
                <header className="flex w-full justify-between p-4">
                    <Link
                        className="focus:outline-dotted focus:outline-1 hocus:brightness-90"
                        to="/"
                    >
                        <img
                            className="w-32"
                            src={logo}
                            alt="Robozinho do XVideos"
                        />
                    </Link>

                    <div className="md:hidden">
                        <Menu>
                            <Link to="/dashboard">Dashboard</Link>
                            <Link to="/dashboard/posts">Posts</Link>
                        </Menu>
                    </div>
                </header>

                <nav className="hidden flex-col md:flex">
                    <Link
                        className={classNames("flex items-center gap-1 p-4", {
                            "border-r-2 border-xv-red bg-xv-bg-2": !route,
                        })}
                        to="/dashboard"
                    >
                        <img
                            className="w-6"
                            src={homeIcon}
                            alt="Ícone de casa"
                        />
                        <span>Dashboard</span>
                    </Link>

                    <Link
                        className={classNames("flex items-center gap-1 p-4", {
                            "border-r-2 border-xv-red bg-xv-bg-2":
                                route === "posts",
                        })}
                        to="/dashboard/posts"
                    >
                        <img
                            className="w-6"
                            src={documentIcon}
                            alt="Ícone de documentos"
                        />
                        <span>Posts</span>
                    </Link>
                </nav>
            </div>

            <main className="flex w-full flex-col items-center p-4">
                {userStatus === "authorized" && <Outlet />}
            </main>
        </div>
    );
}
